// import get from 'lodash/get';
// import find from 'lodash/find';

import { quoteStore } from '../store/quote-store';
import { salesforceStore } from '../store/salesforce-store';

export const populateAppDataFromSalesforceLead = (formik, quoteData) => {
  if (!quoteData) {
    return;
  }
  // console.log("QuoteData:", quoteData)
  quoteStore.quoteRef = quoteData.quoteRef;
  salesforceStore.salesforceLeadId = quoteData.leadId;
  salesforceStore.salesforceOpportunityId = quoteData.opportunityId;

  // const data = get(quoteData, 'transactionData.dataPoints');
  if (!quoteData) {
    return;
  }
  const { setValues, values } = formik;
  // const Quote = get(data, '[0].dataPointData');
  // const Policyholder = get(Quote, 'Policyholder[0]');

  // const unparsedAddress = get(Policyholder, 'Address');

  setValues({
    ...values,
    ...quoteData
  });
  // console.log("Formik::",formik.values)
};
